import { CellFn } from "@/graphHandling/graphTypes";
import { CellId } from "@/processes/CellId";

export const update_suomiCheckbox: CellFn = (
  storeFunctions,
  intl,
  eventPayload
) => {
  if (!eventPayload) return false;

  storeFunctions.addModification(CellId.INITIALIZE_SUOMI_CHECKBOX, {
    isChecked: eventPayload.changeProps.isChecked
  });

  return true;
};
